<mat-form-field  [formGroup]="parentForm" [appearance]="appearance" [color]="color">
  <mat-label>{{label}}</mat-label>
  @if (readonly) {
    <input matInput [formControlName]="name" readonly>
  }
  @if (!readonly) {
    <mat-select [formControlName]="name" [style.background-color]="backgroundColor" (valueChange)="onChange()" >
      @if (default.length) {
        <mat-option [value]="">{{default}}</mat-option>
      }
      @for (option of options; track option) {
        <mat-option [value]="option.value">{{option.text}}</mat-option>
      }
    </mat-select>
  }
</mat-form-field>
